<template>
  <div ref="containerRef" class="tw:relative tw:flex-shrink-0" :style="containerStyle">
    <Transition
      enter-active-class="tw:transition-opacity tw:duration-300"
      enter-from-class="tw:opacity-0"
      enter-to-class="tw:opacity-100"
      leave-active-class="tw:transition-opacity tw:duration-300"
      leave-from-class="tw:opacity-100"
      leave-to-class="tw:opacity-0"
    >
      <div v-if="!isLoaded" class="tw:absolute tw:inset-0">
        <EdroneSkeletonLoader class="tw:rounded-lg" />
      </div>
    </Transition>
    <img
      v-if="shouldLoad"
      :alt="alt"
      :src="src"
      :class="[
        'tw:!h-40 tw:!w-auto tw:rounded-lg tw:shadow tw:border tw:border-default-200 tw:transition-all',
        isLoaded ? 'tw:opacity-100' : 'tw:opacity-0',
      ]"
      @load="handleLoad"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted, computed } from "vue";
import EdroneSkeletonLoader from "edrone-components/EdroneSkeletonLoader.vue";

defineProps<{
  src: string;
  alt: string;
}>();

const containerRef = ref<HTMLElement | null>(null);
const shouldLoad = ref(false);
const isLoaded = ref(false);
let observer: IntersectionObserver | null = null;

const containerStyle = computed(() => ({
  minWidth: "auto",
  height: "10rem",
  aspectRatio: isLoaded.value ? "auto" : "16/9",
}));

const handleLoad = () => {
  isLoaded.value = true;
};

onMounted(() => {
  if (!containerRef.value) return;

  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          shouldLoad.value = true;
          observer?.disconnect();
        }
      });
    },
    { rootMargin: "50px" }
  );

  observer.observe(containerRef.value);
});

onUnmounted(() => {
  observer?.disconnect();
});
</script>
